import { useEffect, useState } from "react"
import { PrintJson } from "../../../theme/Component/PrintJson";
import { _HelpDesk, _single } from "../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { BasicSwitch } from "../../../theme/Component/BasicSwitch";
import { BasicButton } from "../../../theme/Component/BasicButton";
import { toast } from "react-toastify";


interface ProcedureFunctions {
    _exportMap: Function;
    _procedure: any;
    _pocessData?: any;
    _pushInfo?: Function;
    _pushProps?: Function;
}

interface Props {
    configProcedure: ProcedureFunctions;
}
export const HD003 = ({ configProcedure }: Props) => {

    const [props, setProps] = useState<any>({});
    const { _procedure, _pocessData, _exportMap, _pushInfo, _pushProps } = configProcedure;
    const _helpDesk = useDataBean(_HelpDesk);
    const { bean, setBean, handleChange } = _helpDesk;
    const account = _single.getAccount();

    useEffect(() => {
        if (_pocessData?.Props) {
            setProps(_pocessData?.Props)
        }
        setBean(
            {
                State: true,
                Solucion: ''
            }
        )
    }, [configProcedure?._pocessData])

    const responseCaso = () => {
        if (bean.Solucion.length > 15) {
            const resuelto = {
                "Funcionario Resuleve": account.EmployeeName,
                "Observaciones": bean.Solucion,
                "Estado de la soluciòn": bean.State === true ? 'Resuelta' : 'Se remite para clasificación',
            }
            _pushInfo(_single.jsonToBootstrapTable(resuelto));
            _pushProps({
                RESUELTA: bean.State === true ? 1 : 0,
                IDRESUELVE: _single.getAccountID()
            })
            _exportMap({
                RESUELTA: bean.State === true ? 1 : 0,
                OBSSOLCUION: bean.Solucion,
                IDRESUELVE: _single.getAccountID()
            })
        } else {
            toast.warning("Por favor incluya un mensaje de minimo 15 carateres.");
        }
    }

    return (
        <div className="row">
            <div className="col-md-6">
                <label>Solicitante</label>
                <input type="text" name="sol" readOnly value={props.Solicitante} className="form-control" />
            </div>
            <div className="col-md-6">
                <label>Fecha</label>
                <input type="text" name="sol" readOnly value={props.Since} className="form-control" />
            </div>
            <div className="col-md-12">
                <label>Solicitud</label>
                <textarea className="form-control" value={props.Observation} readOnly></textarea>
            </div>
            <div className="col-md-12">
                <label>Observaciones Adicionales</label>
                <textarea className="form-control" value={props.OBSRechazo} readOnly></textarea>
            </div>
            <div className="col-md-12">
                <hr />
                <div className="row">
                    <div className="col-md-12">
                        <label>Observaciones de la solución</label>
                        <textarea className="form-control" value={bean.Solucion} name="Solucion" onChange={handleChange} placeholder="Deje una descripción de la solución"></textarea>
                    </div>
                    <div className="col-md-6">
                        <BasicSwitch label="Se cierra el caso ?" estado={bean.State} eventChange={(e) => { setBean({ ...bean, "State": e }) }} />
                        <BasicButton disable={bean.Solucion == ''} icon="ri-send-plane-fill" eventClick={responseCaso} useMargin>Enviar</BasicButton>
                    </div>

                </div>
            </div>
            <div className="col-md-12">
                {/* <PrintJson json={bean} />
                <PrintJson json={account} /> */}
            </div>
        </div>
    )
}